
import LargeModal from "components/elements/LargeModal";
import Table from "components/elements/Table";
import utility from "core/Utils";
import dataProvider from "core/DataProvider";
import { toast } from "react-hot-toast";
import { useEffect, useState } from "react";
import "../../../styles/group_tab.css";

const GroupMonthlyBill = props => {
    //console.log(Object.values(props));
    // const [isEditing, setIsEditing] = useState(false);

    const [bill_list, setBillList] = useState([]);
    const onClose = (action = null) => {
        if (props.onClose !== undefined) {
            props.onClose(action);
        }
    };
    const headerMap = {
        month: "Month",
        bill_spots: "Bill Spots",
        bill_rate: "Rate",
        bill_amount: "Bill Amount"
    };
    //const [groupspotlist, setGroups] = useState([]);
    //const [search, setSearch] = useState("");
    //const [loading, setLoading] = useState(true);


    const get_group_bil_List = async () => {
        // setLoading(true);
        try {
            const data = await dataProvider.network.get(`billing/group-month/${props.data.gid}`);
            const transformed = data.map(x => ({
                ...x,
                month: utility.formatDate(x.BillingMonth),
                bill_spots: x.TotalSpots,
                bill_rate:x.SpotsRate,
                bill_amount: x.TotalAmount
            }));

            // Calculate totals
            const totalSpots = transformed.reduce((sum, item) => sum + item.bill_spots, 0);
            const totalAmount = transformed.reduce((sum, item) => sum + item.bill_amount, 0);

            // Add summary row
            const summaryRow = {
                month: "Total",
                bill_spots: totalSpots,
                bill_amount: parseFloat(totalAmount.toFixed(2))
            };

            setBillList([...transformed, summaryRow]);
            // console.log(data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch billing overview list");
        } finally {
            // setLoading(false);
        }
    };



    useEffect(() => {
        get_group_bil_List();
    },[]);
    return (
        <LargeModal onClose={onClose}>

            <div className="flex flex-v-center">
                <h1>  {props.data.grp_heading}</h1>
                <div className="right flex">
                    <div className="el">

                    </div>
                </div>
            </div>
            <div className="flex sub-preview-wrapper">
                <div className="sub-preview-details">
                    <div className="table-wrapper">
                        <div className="table-data-grp" >
                            <Table
                                headers={headerMap}
                                data={bill_list} pagination={false}
                                rowClassName={row => row.month === "Total" ? "summary-row" : ""}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </LargeModal>
    );
};

export default GroupMonthlyBill;
